<template>
  <div v-if="state.rules.visible">
    <div v-html="content"></div>
    <p class="hr-field-content__helper">{{ state.theField?.help?.hint }}</p>
  </div>
</template>

<script>
import { getTypeValidator, typeTranslation } from '@/core/input-types/utils';
import { reactive } from 'vue';

export default {
  name: 'hr-field-content',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    owner: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const state = reactive({
      theField: props.value,
      rules: {
        visible: true,
      },
      viewSensitive: props.owner,
      fieldValidation: {},
    });

    async function initialize() {
      const type = await typeTranslation(state.theField.type);

      if (type.validation) {
        state.fieldValidation = await getTypeValidator(type.validation);
        state.theField.validation = Object.assign(
          {},
          state.theField.validation,
          state.fieldValidation
        );

        if (state.fieldValidation.type) {
          type.type = state.fieldValidation.type;
        }
      }
      if (state.theField.appliedRules) {
        Object.keys(state.theField.appliedRules).forEach(
          (rule) => (state.rules[rule] = state.theField.appliedRules[rule])
        );
      }

      if (
        state.theField.type === 'LINK' ||
        state.theField.type === 'LINK_BUTTON'
      ) {
        state.rules.visible = false;
      }
    }

    initialize();

    return {
      state,
    };
  },
};
</script>

<style>
.hr-field-content__helper {
  margin-top: 4px;
  font-size: 14px;
  color: var(--co-text-secondary);
}
</style>
